export default "__VITE_ASSET__7dXxsX$$__"